import { NgModule } from '@angular/core';
import { RangeEventsDirective } from './range-events.directive';

@NgModule({
  imports: [],
  declarations: [RangeEventsDirective],
  exports: [RangeEventsDirective]
})
export class DirectivesModule { }
